import { render } from "./ProjectsInfo.vue?vue&type=template&id=5ffea7b3"
import script from "./ProjectsInfo.vue?vue&type=script&lang=js"
export * from "./ProjectsInfo.vue?vue&type=script&lang=js"

import "./ProjectsInfo.vue?vue&type=style&index=0&id=5ffea7b3&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__